module.exports = __webpack_public_path__ + "static/media/stat-sample.fd2e4493.png";